// ── Set after deploying VaultFactory ─────────────────────────
export const FACTORY_ADDRESS = "0xb369a29fa2881B11c2a10B0100E952FDdDe2FD61" as `0x${string}`;

export const BASE_CHAIN_ID = 8453;

export const FACTORY_ABI = [
  "function getAllVaults() external view returns (address[])",
  "function vaultCount() external view returns (uint256)",
  "function getVaultInfo(address vault) external view returns (address lpToken, address gauge, string name, uint256 totalLp, uint256 sharePrice, uint256 pending, uint256 perfFee, uint256 withdrawFee, uint256 lastHarvest)",
] as const;

export const VAULT_ABI = [
  "function deposit(uint256 lpAmount) external returns (uint256 shares)",
  "function withdraw(uint256 shares) external returns (uint256 lpOut)",
  "function emergencyWithdraw(uint256 shares) external returns (uint256 lpOut)",
  "function harvest(uint256 minToken0Out, uint256 minToken1Out) external",
  "function balanceOf(address account) external view returns (uint256)",
  "function totalSupply() external view returns (uint256)",
  "function totalLpManaged() external view returns (uint256)",
  "function pricePerShare() external view returns (uint256)",
  "function pendingRewards() external view returns (uint256)",
  "function perfFeeBps() external view returns (uint256)",
  "function withdrawFeeBps() external view returns (uint256)",
  "function getLpForShares(uint256 shares) external view returns (uint256)",
  "function lastHarvestTimestamp() external view returns (uint256)",
  "function lpToken() external view returns (address)",
  "function vaultName() external view returns (string)",
  "function totalFeesCollected() external view returns (uint256)",
  "function totalWithdrawFeesCollected() external view returns (uint256)",
  "function totalRewardsCompounded() external view returns (uint256)",
  "function isStable() external view returns (bool)",
] as const;

export const ERC20_ABI = [
  "function balanceOf(address) external view returns (uint256)",
  "function approve(address spender, uint256 amount) external returns (bool)",
  "function allowance(address owner, address spender) external view returns (uint256)",
  "function decimals() external view returns (uint8)",
  "function symbol() external view returns (string)",
] as const;

// Brand colors
export const COLORS = {
  primary:    "#6366f1", // indigo
  primaryDark:"#4f46e5",
  accent:     "#a78bfa", // purple
  green:      "#34d399",
  red:        "#f87171",
  yellow:     "#fbbf24",
  bg:         "#0a0a1a",
  bgCard:     "#111128",
  bgInput:    "#0d0d20",
  border:     "#1e1e3f",
  textPrimary:"#f1f5f9",
  textMuted:  "#64748b",
  textSub:    "#94a3b8",
};
